import { ColorName } from '@emotion/react';
import { IconName } from 'design-system/base';

interface Base {
  id: string;
  display: string;
  selected?: boolean;
  color?: ColorName;
}

export interface Comment extends Base {
  type: 'comment';
  text?: string;
  textRequired?: boolean;
}

export type Node = Group | Comment;

export interface Group extends Base {
  type: 'group';
  children: Array<Node>;
  icon?: IconName;
}

export interface BaseItemPillProps<TNode extends Node> {
  node: TNode;
  onUnSelect: () => void;
  onSelect: () => void;
  onTextChange?: (text?: string) => void;
}

export interface CommentWithPath extends Comment {
  path: string;
}
